import React from "react";
import ReactDOM from "react-dom";
import UnauthorizedBase from "../../../Base/views/UnauthorizedBase";
import MaterialTable, { MTableBody, MTableToolbar } from "material-table";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Tooltip,
  Typography,
  Popover,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useSelector, useDispatch } from "react-redux";
import Drawer from '@mui/material/Drawer';
import FilterListIcon from "@mui/icons-material/FilterList";
import { TeamTimeFilter, TeamTimeAppliedFilter } from "../TeamTimeFilter";
import { GetAllRecordsTimeDataHelper, GetTimeDataHelper } from "../../helper/Team/TeamHelper";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import {
  ConvertDate,
  ConvertTime,
  DateConvertInDbFormat,
  formatTimeDuration,
  getImageSignedUrl,
} from "../../../Base/helper/baseFunctions";
import { toast } from "react-toastify";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import ClearIcon from "@mui/icons-material/Clear";
import { GetUserWorkLocationHelper } from "../../../Employee/helper/EmployeeHelper";
import { GetBusinessUnitHelper } from "../../../Ancillary/BusinessUnit/helper/BusinessUnitHelper";
import { GetShiftTimeConfigureHelper } from "../../../Leave/helper/ShiftTimeConfigureHelper";
import { GetEmploymentTypeHelper } from "../../../Ancillary/EmploymentType/helper/EmploymentTypeHelper";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import Chart from 'react-apexcharts';
import Popup from '../../../Base/views/Popup';
import { getFaceDataHelper, getWhatsappTimesheetHelper } from '../../../FaceAttendance/helper/FaceRecognizationHelper';
import {formatAttendanceRow, formatDistance} from "../../helper/TimeHelper/TimeHelper";
import CustomToggle from '../../../Base/views/CustomToggle';
import PublicAttendanceDashboard from './PublicAttendanceDashboard';
import YetToCheckInPopup from '../Team/YetToCheckInPopup';
import OnLeavePopup from '../Team/OnLeavePopup';

const TeamTimePublic = () => {
  const [isDashboardView, setIsDashboardView] = useState(true);
  const [yetToCheckInOpen, setYetToCheckInOpen] = useState(false);
  const [isYetToCheckInKpi, setIsYetToCheckInKpi] = useState(false);
  const [onLeaveOpen, setOnLeaveOpen] = useState(false);
  const [isOnLeaveKpi, setIsOnLeaveKpi] = useState(false);
  const [kpiFilters, setKpiFilters] = useState(null);
  const [kpiReportingManagerId, setKpiReportingManagerId] = useState(null);

  const handleToggleView = (val) => {
    const nextView = typeof val === "boolean" ? val : !isDashboardView;
    handleClearFilter();
    setIsDashboardView(nextView);
  };
  const [toolbarNode, setToolbarNode] = useState(null);
  const [empdata, setEmpData] = useState([]);
  const { domain, userToken } = useParams();
  const decodedPayload = JSON.parse(atob(userToken));
  const date = new Date();
  const theme = useTheme();
  const currentDate = new Date();
  const formattedToday = `${currentDate.getFullYear()}-${(
    currentDate.getMonth() + 1).toString()
    .padStart(2, "0")}-${currentDate.getDate().toString().padStart(2, "0")}`;

  const default_date = `${date?.getFullYear() +
    "-" +
    ("0" + (date?.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date?.getDate()).slice(-2)
    }`;
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    employee_id: [],
    full_date: default_date,
    from_date: DateConvertInDbFormat(),
    to_date: DateConvertInDbFormat(),
    ats_work_location_id: []
  });
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const { employees_options } = useSelector(
    (state) => state.EmployeeReducer.EmployeesReducer
  );

  const handleEmployees = () => {
    employees_options &&
      setEmployeesData({ load: false, values: employees_options });
  };
  const [isLoading, setIsLoading] = useState(false);
  const [isCsvLoading, setIsCsvLoading] = useState(false);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [showCustomRange, setShowCustomRange] = useState(false);
  const [customFromDate, setCustomFromDate] = useState(filters.from_date);
  const [customToDate, setCustomToDate] = useState(filters.to_date);
  const [anchorEl, setAnchorEl] = useState(null);
  const [worklocationData, setWorklocationData] = useState({
    load: true,
    values: [],
  });
  const showWorkLocation = !worklocationData.load && worklocationData.values.length > 1;
  const [chartOpen, setChartOpen] = useState(false);
  const [transactionDialogOpen, setTransactionDialogOpen] = useState(false);
  const [transactionRows, setTransactionRows] = useState([]);
  const [transactionSummary, setTransactionSummary] = useState(null);
  const [transactionVisitor, setTransactionVisitor] = useState(null);
  const [transactionLoading, setTransactionLoading] = useState(null);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [businessUnitData, setBusinessUnitData] = useState([]);
  const [businessUnitValue, setBusinessUnitValue] = useState([]);
  const [shiftData, setShiftData] = useState([]);
  const [shiftValue, setShiftValue] = useState([]);
  const [employmentTypeData, setEmploymentTypeData] = useState([]);
  const [employmentTypeValue, setEmploymentTypeValue] = useState([]);
  const [empNoValue, setEmpNoValue] = useState([]);
  const [fullEmpData, setFullEmpData] = useState([]);

  const handleShowTransactions = async (rowData) => {
    setTransactionVisitor(rowData);
    setTransactionDialogOpen(true);
    setTransactionLoading(true);
    setTransactionRows([]);

    let response = {};
    let attendanceType = 'Face Attendance';
    if (rowData?.in_mode === 'Whatsapp Attendance' || rowData?.out_mode === 'Whatsapp Attendance') {
        attendanceType = 'Whatsapp Attendance';
        response = await getWhatsappTimesheetHelper({
            domain_name: domain,
            emp_id: rowData?.employee_pk,
            from_date: rowData.record_date,
            to_date: rowData.record_date,
            reporting_manager_emp_id: null
        });
    } else { // if in_mode or out_mode is 'App Attendance', 'Face Attendance'
        response = await getFaceDataHelper({
          domain_name: domain,
          emp_id: rowData?.employee_pk,
          from_date: rowData.record_date,
          to_date: rowData.record_date,
          reporting_manager_emp_id: null
        });
    }
 

    if (response?.data?.statuscode === 200) {
        const rawPunches = response?.data?.data || [];
        const punches = rawPunches?.map(p => ({
            ...p,
            attendance_type: attendanceType
        }));
        let total_check_ins = 0;
        let total_check_outs = 0;
        punches?.forEach(p => {
            if (p?.in_time) total_check_ins++;
            if (p?.out_time) total_check_outs++;
        });
        setTransactionRows(punches);
        setTransactionSummary({
            total_check_ins,
            total_check_outs,
        });
    } else {
      setTransactionRows([]);
      setTransactionSummary(null);
      toast.error(response?.data?.error?.[0]?.message || "Failed to load punches data");
    }

    setTransactionLoading(false);
  };

  const formatTime = (date) => {
    if (!date) return "N/A";
    const time = new Date(date);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return time.toLocaleString("en-US", options);
  };

  const renderTimeCell = (timeValue, showDate = true) => {
    if (!timeValue) return "-";
    const dateObj = new Date(timeValue);
    const day = String(dateObj.getUTCDate()).padStart(2, "0");
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthName = months[dateObj.getUTCMonth()];
    const formattedTime = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC",
    });
    const displayStr = showDate ? `${day} ${monthName}, ${formattedTime}` : formattedTime;
    const detailedStr = ConvertTime(timeValue, true);
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
        <span>{displayStr}</span>
        <Tooltip title={detailedStr} arrow>
          <InfoOutlinedIcon
            fontSize="small"
            color="primary"
            style={{ cursor: "pointer", fontSize: "16px" }}
          />
        </Tooltip>
      </div>
    );
  };

  const renderModeCell = (modeVal, isFaceAttendance, locationDisplayName, locationDistance) => {
    if (!modeVal || modeVal === "-") return "-";

    if (locationDisplayName) {
      const tooltipText = (
        <>
          <div>• Marked at: {locationDisplayName}</div>
          {locationDistance && (
            <div>• Distance from office: {locationDistance}</div>
          )}
        </>
      );
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>{modeVal}</span>
          <Tooltip title={tooltipText} arrow>
            <InfoOutlinedIcon
              fontSize="small"
              color="primary"
              style={{ cursor: "pointer", fontSize: "16px" }}
            />
          </Tooltip>
        </div>
      );
    }

    return modeVal;
  };

  useEffect(() => {
    if (!isDashboardView) {
      dispatch(GetEmployeesAction({
        is_active: true, domain,
        user_id: decodedPayload.user_id
      }));
      handleWorkLoacation();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDashboardView]);
  useEffect(() => {
    if (isDashboardView) return;
    setIsLoading(true);
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    GetTimeDataHelper({
      domain_name: domain,
      reporting_manager_emp_id: decodedPayload.userId,
      from_date: filters?.from_date,
      to_date: filters?.to_date,
      emp_id: (filters?.employee_id || [])?.length > 0
        ? `{${filters.employee_id.map(e => e.employee_id).join(',')}}`
        : null,
      ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
      user_id: decodedPayload.user_id,
      business_unit: businessUnitValue?.length > 0 ? `{${businessUnitValue.map(bu => bu.businessunit_id).filter(Boolean).join(',')}}` : null,
      employee_no: empNoValue?.length > 0 ? `{${empNoValue.map(emp => `"${emp}"`).join(',')}}` : null,
      shift_ids: shiftValue?.length > 0 ? `{${shiftValue.map(s => s.shift_roster_configuration_id).filter(Boolean).join(',')}}` : null,
      employment_type_ids: employmentTypeValue?.length > 0 ? `{${employmentTypeValue.map(e => e.employmenttype_id).filter(Boolean).join(',')}}` : null

    }).then((res) => {
      const formatted = (res?.data?.data || []).map(formatAttendanceRow);
      setFullEmpData(formatted);
      setEmpData(formatted);
    }).finally(() => {
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, businessUnitValue, empNoValue, shiftValue, employmentTypeValue, isDashboardView]);



  const getReportTitle = () => {
    let employeeLabel = "";
    if ((filters?.employee_id || [])?.length === 1) {
      employeeLabel = `${filters.employee_id[0].name} - `;
    } else if ((filters?.employee_id || [])?.length > 1) {
      employeeLabel = "Multiple Employees - ";
    }
    const dateRangeStr = filters.from_date === filters.to_date
      ? ConvertDate(filters.from_date)
      : `${ConvertDate(filters.from_date)} - ${ConvertDate(filters.to_date)}`;
    return `${employeeLabel}Attendance Report (${dateRangeStr})`;
  };

  const getChartData = () => {
    const totalCheckIns = empdata.filter(row => row?.in_mode && row?.in_mode !== '-').length;
    const totalCheckOuts = empdata.filter(row => row?.out_mode && row?.out_mode !== '-').length;

    return {
      series: [
        {
          name: 'Count',
          data: [totalCheckIns, totalCheckOuts]
        }
      ],
      options: {
        chart: {
          type: 'bar',
          fontFamily: 'Nunito Sans, sans-serif',
          toolbar: { show: false }
        },
        colors: ['#90caf9', '#1976d2'],
        plotOptions: {
          bar: {
            columnWidth: '50%',
            distributed: true,
            borderRadius: 4,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#475569']
          }
        },
        legend: {
          show: false
        },
        grid: {
          borderColor: "#F1F5F9",
          strokeDashArray: 4,
          yaxis: {
            lines: {
              show: false
            }
          },
          padding: {
            top: 25,
            right: 15,
            bottom: 0,
            left: 15
          }
        },
        xaxis: {
          categories: ['Punch In', 'Punch Out'],
          labels: {
            style: {
              fontSize: '13px',
              fontWeight: 700,
              colors: ['#475569', '#475569']
            }
          }
        },
        yaxis: {
          show: false,
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (val) {
              return val + " logs";
            }
          }
        }
      }
    };
  };
  const handleFilter = (event, value) => {
    if (["employee_id"].includes(event)) {
      setFilters({ ...filters, [event]: value });
    }
    const MAX_RANGE = 45;
    if (["from_date"].includes(event?.target?.name)) {
      let newFromDate = event?.target?.value;
      let newToDate = filters.to_date;

      const diff = getDayDiff(newFromDate, newToDate);

      if (diff > MAX_RANGE) {
        // auto-shift TO DATE
        const candidateToDate = addDays(newFromDate, MAX_RANGE);
        newToDate =
          new Date(candidateToDate) > new Date(currentDate)
            ? DateConvertInDbFormat(currentDate)
            : candidateToDate;
      }

      setFilters({
        ...filters,
        from_date: newFromDate,
        to_date: newToDate,
      });
      return;
    }

    if (["to_date"].includes(event?.target?.name)) {
      let newToDate = event?.target?.value;
      let newFromDate = filters.from_date;

      const diff = getDayDiff(newFromDate, newToDate);

      if (diff > MAX_RANGE) {
        newFromDate = subtractDays(newToDate, MAX_RANGE);
      }
      setFilters({
        ...filters,
        from_date: newFromDate,
        to_date: newToDate,
      });
    }
  };

  const handleExportMenuOpen = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportMenuClose = () => {
    setExportAnchorEl(null);
  };

  const handleExportSummarised = async () => {
    handleExportMenuClose();
    setIsCsvLoading(true);
    try {
      const headers = [
        { label: "Emp No", key: "employee_no" },
        { label: "Name", key: "employee_name" },
        { label: "Attendance Date", key: "record_date" },
        { label: "Business Unit", key: "business_unit" },
        { label: "Shift", key: "shift_name" },
        ...(showWorkLocation ? [{ label: "Work Location", key: "work_location_name" }] : []),
        { label: "In Mode", key: "in_mode" },
        { label: "Out Mode", key: "out_mode" },
        { label: "In Location", key: "in_location_display_name" },
        { label: "In Distance from office", key: "in_location_distance" },
        { label: "Out Location", key: "out_location_display_name" },
        { label: "Out Distance from office", key: "out_location_distance" },
        { label: "First Check-In", key: "in_time" },
        { label: "Last Check-Out", key: "out_time" },
        { label: "Total Hours", key: "total_seconds" },
      ];

      const fromDateStr = filters?.from_date ? ConvertDate(filters.from_date) : '';
      const toDateStr = filters?.to_date ? ConvertDate(filters.to_date) : '';
      let reportPeriod = 'Attendance Report - Summary';
      if (fromDateStr && toDateStr) {
        reportPeriod = fromDateStr === toDateStr
          ? `Attendance Report (Summary) - Date: ${fromDateStr}`
          : `Attendance Report (Summary) - Period: ${fromDateStr} to ${toDateStr}`;
      } else if (fromDateStr) {
        reportPeriod = `Attendance Report (Summary) - From: ${fromDateStr}`;
      }
      const csvData = [[`"${reportPeriod.replace(/"/g, '""')}"`], [], headers.map(h => h.label)];

      empdata?.forEach(row => {
        const rowData = headers.map(h => {
          let value = row[h.key];

          // Apply ConvertTime only for time fields
          if (h.key === "in_time" && value) {
            value = ConvertTime(value, true);
          }
          if (h.key === "out_time" && value) {
            value = ConvertTime(value, true);
          }
          if (h.key === "total_seconds" && value) {
            value = formatTimeDuration(value);
          }
          if (h.key === "record_date" && value) {
            value = ConvertDate(value);
          }

          // CSV-safe formatting
          if (value === null || value === undefined) return "";
          if (typeof value === "string") {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        });

        csvData.push(rowData);
      });

      const csv = csvData.map((row) => row.join(",")).join("\n");
      const blob = new Blob(["\uFEFF" + csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = `${reportPeriod.replace(/[/\\?%*:|"<>]/g, '-')}.csv`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(`Error generating CSV: ${err.message}`);
    } finally {
      setIsCsvLoading(false);
    }
  };

  const handleExportConsolidated = async () => { 
      handleExportMenuClose();
      setIsCsvLoading(true);
      try {
          const locationPayload = Array.isArray(filters?.ats_work_location_id) && filters.ats_work_location_id.length > 0
              ? JSON.stringify(filters.ats_work_location_id.map((item) => ({ ats_work_location_id: item?.work_location_id })))
              : null;
          const res = await GetAllRecordsTimeDataHelper({
              domain_name: domain,
              reporting_manager_emp_id: decodedPayload.userId,
              from_date: filters?.from_date,
              to_date: filters?.to_date,
              emp_id: (filters?.employee_id || [])?.length > 0
                ? `{${filters.employee_id.map(e => e.employee_id).join(',')}}`
                : null,
              ats_work_location_json: locationPayload,
              user_id: decodedPayload.user_id,
              business_unit: businessUnitValue?.length > 0 ? `{${businessUnitValue.map(bu => bu.businessunit_id).filter(Boolean).join(',')}}` : null,
              employee_no: empNoValue?.length > 0 ? `{${empNoValue.map(emp => `"${emp}"`).join(',')}}` : null,
              shift_ids: shiftValue?.length > 0 ? `{${shiftValue.map(s => s.shift_roster_configuration_id).filter(Boolean).join(',')}}` : null,
              employment_type_ids: employmentTypeValue?.length > 0 ? `{${employmentTypeValue.map(e => e.employmenttype_id).filter(Boolean).join(',')}}` : null

          });

          let recordsData = [];
          let primaryData  = empdata || [];
          if (res?.data?.statuscode === 200) {
              recordsData = res?.data?.data?.[0]?.fn_get_all_records_staging_meepl_common_time || [];
          }

          const summaryHeaders = [
              { label: "Emp No", key: "employee_no" },
              { label: "Name", key: "employee_name" },
              { label: "Attendance Date", key: "record_date" },
              { label: "Business Unit", key: "business_unit" },
              { label: "Shift", key: "shift_name" },
              { label: "Work Location", key: "work_location_name" },
              { label: "In Mode", key: "in_mode" },
              { label: "Out Mode", key: "out_mode" },
              { label: "In Location", key: "in_location_display_name" },
              { label: "In Distance from office", key: "in_location_distance" },
              { label: "Out Location", key: "out_location_display_name" },
              { label: "Out Distance from office", key: "out_location_distance" },
              { label: "First Check-In", key: "in_time" },
              { label: "Last Check-Out", key: "out_time" },
              { label: "Total Hours", key: "total_seconds" },
              { label: "Total Punch-Ins", key: "total_punch_ins" },
              { label: "Total Punch-Outs", key: "total_punch_outs" },
          ];

          const punchHeaders = [
              { label: "Punch In", key: "in_time" },
              { label: "Punch In Location", key: "in_location_display_name" },
              { label: "Punch Out", key: "out_time" },
              { label: "Punch Out Location", key: "out_location_display_name" },
          ];

          const fromDateStr = filters?.from_date ? ConvertDate(filters.from_date) : '';
          const toDateStr = filters?.to_date ? ConvertDate(filters.to_date) : '';
          let reportPeriod = 'Attendance Report - Detailed';
          if (fromDateStr && toDateStr) {
              reportPeriod = fromDateStr === toDateStr
                  ? `Attendance Report (Detailed) - Date: ${fromDateStr}`
                  : `Attendance Report (Detailed) - Period: ${fromDateStr} to ${toDateStr}`;
          } else if (fromDateStr) {
              reportPeriod = `Attendance Report (Detailed) - From: ${fromDateStr}`;
          }

          const headerLabels = [...summaryHeaders.map(h => h.label), ...punchHeaders.map(h => h.label)];

          const csvData = [[`"${reportPeriod.replace(/"/g, '""')}"`], [], headerLabels];

          // Helper for location
          const getLocationName = (location) => {
              if (!location) return "";
              try {
                  const locObj = typeof location === "string" ? JSON.parse(location) : location;
                  return locObj?.displayName || location;
              } catch (e) {
                  return location;
              }
          };

          // Group punch records by employee_pk + record_date
          const punchesByEmployee = {};

          for (const record of recordsData) {
              const key = `${record?.employee_pk}_${record?.record_date}`;
              if (!punchesByEmployee[key]) {
                  punchesByEmployee[key] = [];
              }
              punchesByEmployee[key].push(record);
          }

          // Process primary data
          for (const primary of primaryData) {

              const employeeId = primary?.employee_pk;
              const recordDate = primary?.record_date;
              const key = `${employeeId}_${recordDate}`;

              const employeePunches = punchesByEmployee[key] || [];

              const summaryRowData = summaryHeaders?.map(header => {
                  let value = primary?.[header.key];

                  if (header.key === "in_mode") {
                      value = primary?.in_mode || employeePunches?.[0]?.mode || "";
                  }

                  if (header.key === "out_mode") {
                      const lastPunchWithOut = [...employeePunches]
                          .reverse().find(p => p?.out_time);
                      value = primary?.out_mode || lastPunchWithOut?.mode || "";
                  }

                  if (header.key === "in_location_display_name") {
                      value = getLocationName(primary?.in_location_name);
                  }

                  if (header.key === "out_location_display_name") {
                      value = getLocationName(primary?.out_location_name);
                  }

                  if (header.key === "in_location_distance") {
                      value = primary?.in_location_distance || primary?.in_location || "";
                  }

                  if (header.key === "out_location_distance") {
                      value = primary?.out_location_distance || primary?.out_location || "";
                  }

                  if (header.key === "total_punch_ins") {
                      value = employeePunches?.filter(p => p?.in_time).length;
                  }

                  if (header.key === "total_punch_outs") {
                      value = employeePunches?.filter(p => p?.out_time).length;
                  }

                  if ((header.key === "in_time" || header.key === "out_time") && value) {
                      value = ConvertTime(value, true);
                  }

                  if (header.key === "total_seconds") {
                      if (primary?.total_hours) {
                          value = primary?.total_hours;
                      } else if (value) {
                          value = formatTimeDuration(value);
                      }
                  }

                  if (header.key === "record_date" && value) {
                      value = ConvertDate(value);
                  }

                  if (value === null || value === undefined) {
                      return "";
                  }

                  if (typeof value === "string") {
                      return `"${value
                          .replace(/"/g, '""')
                          .replace(/\r?\n|\r/g, ' ')}"`;
                  }

                  return value;
              });
          csvData.push([
              ...summaryRowData,
              ...Array(punchHeaders.length).fill("")
          ]);

          for (const punch of employeePunches) {
              const punchData = punchHeaders.map(header => {
                  let value = punch?.[header.key];
                  if (header.key === "in_location_display_name") {
                      value = getLocationName(punch?.in_location_name);
                  }
                  if (header.key === "out_location_display_name") {
                      value = getLocationName(punch?.out_location_name);
                  }
                  if (
                      (header.key === "in_time" || header.key === "out_time") &&
                      value
                  ) {
                      value = ConvertTime(value, true);
                  }
                  if (value === null || value === undefined) {
                      return "";
                  }
                  if (typeof value === "string") {
                      return `"${value
                          .replace(/"/g, '""')
                          .replace(/\r?\n|\r/g, ' ')}"`;
                  }
                  return value;
              });

              csvData.push([
                  ...Array(summaryHeaders.length).fill(""),
                  ...punchData
              ]);
          }
          }

          const csv = csvData.map((r) => r.join(",")).join("\n");
          const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
          const url = URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = `${reportPeriod.replace(/[/\\?%*:|"<>]/g, '-')}.csv`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(url);
      } catch (error) {
          console.error("Error exporting consolidated data:", error);
          toast.error("Failed to export consolidated data");
      } finally {
          setIsCsvLoading(false);
      }
  };
  useEffect(() => {
    const fetchImage = async () => {
      try {
        const url = await getImageSignedUrl(decodedPayload?.image);
        setImageUrl(url);
      } catch (error) {
        console.error("Error fetching signed URL:", error);
      }
    };

    if (decodedPayload?.image) {
      fetchImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decodedPayload?.image]);
  const handleDateRangeChange = (option) => {
    const today = new Date();
    let fromDate, toDate;

    if (option === "custom") {
      setShowCustomRange(true);
      setFilters({ ...filters, dateRangeOption: option });
      return;
    } else {
      setShowCustomRange(false);
    }

    switch (option) {
      case "today":
        fromDate = toDate = today;
        break;

      case "yesterday":
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        fromDate = toDate = yesterday;
        break;

      case "last7":
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 6);
        fromDate = sevenDaysAgo;
        toDate = today;
        break;

      case "lastMonth":
        fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        toDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

      default:
        return;
    }

    const formatDate = (date) =>
      `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${(
        "0" + date.getDate()
      ).slice(-2)}`;

    const formattedFrom = formatDate(fromDate);
    const formattedTo = formatDate(toDate);

    setCustomFromDate(formattedFrom);
    setCustomToDate(formattedTo);

    setFilters({
      ...filters,
      from_date: formattedFrom,
      to_date: formattedTo,
      dateRangeOption: option,
    });
  };
  const handleClear = () => {
    setCustomFromDate(formattedToday);
    setCustomToDate(formattedToday);
    setFilters({
      ...filters,
      dateRangeOption: "",
      from_date: formattedToday,
      to_date: formattedToday,
    });
    setShowCustomRange(false);
  };
  const handleCustomDateChange = (name, value) => {
    const formattedValue = value
      ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
      : "";

    const MAX_RANGE = 45;
    if (name === "from_date") {
      let newFromDate = formattedValue;
      let newToDate = customToDate;

      const diff = getDayDiff(newFromDate, newToDate);

      if (diff > MAX_RANGE) {
        const candidateToDate = addDays(newFromDate, MAX_RANGE);
        newToDate =
          new Date(candidateToDate) > new Date(currentDate)
            ? DateConvertInDbFormat(currentDate)
            : candidateToDate;
      }
      setCustomFromDate(newFromDate);
      setCustomToDate(newToDate);
    } else if (name === "to_date") {
      let newToDate = formattedValue;
      let newFromDate = customFromDate;

      const diff = getDayDiff(newFromDate, newToDate);

      if (diff > MAX_RANGE) {
        newFromDate = subtractDays(newToDate, MAX_RANGE);
      }
      setCustomFromDate(newFromDate);
      setCustomToDate(newToDate);
    }
  };
  const handleApplyCustomRange = () => {
    setFilters({
      ...filters,
      from_date: customFromDate,
      to_date: customToDate,
    });
  };
  const handleWorkLoacation = () => {
    GetUserWorkLocationHelper({
      domain_name: domain,
      user_id: decodedPayload.user_id
    }).then(res => {
      if (res?.data?.statuscode === 200) {
        setWorklocationData({ load: false, values: res?.data?.data || [] })
      } else {
        setWorklocationData({ load: false, values: [] })
      }
    })
  }

  const handleBusinessUnit = () => {
    GetBusinessUnitHelper({ domain_name: domain }).then(res => {
      if (!res.hasError) {
        setBusinessUnitData(res.data?.data || []);
      }
    });
  }

  const handleShiftData = () => {
    GetShiftTimeConfigureHelper({ domain_name: domain }).then(res => {
      if (!res.hasError) {
        setShiftData(res.data?.data || []);
      }
    });
  }

  const handleEmploymentTypeData = () => {
    GetEmploymentTypeHelper({ domain_name: domain }).then(res => {
      if (!res.hasError) {
        setEmploymentTypeData(res.data?.data || []);
      }
    });
  }

  useEffect(() => {
    if (!isDashboardView) {
      handleBusinessUnit();
      handleShiftData();
      handleEmploymentTypeData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDashboardView]);


  const handleWorkLocationChange = (data, e) => {
    if (e.target.checked === false || e.type === "click") {
      const updated = (filters.ats_work_location_id || []).filter(element => element.work_location_id !== data.work_location_id);
      setFilters({ ...filters, ats_work_location_id: updated });
    } else {
      setFilters({ ...filters, ats_work_location_id: [...(filters.ats_work_location_id || []), data] });
    }
  };

  const handleBusinessUnitChange = (data, e) => {
    if (e.target.checked === false || e.type === "click") {
      setBusinessUnitValue(businessUnitValue.filter(element => element.businessunit_id !== data.businessunit_id));
    } else {
      setBusinessUnitValue([...businessUnitValue, data]);
    }
  };

  const handleDepartmentRowClick = (deptRow, dashDate) => {
    const rawDeptId = deptRow?.department_id ?? (deptRow?.rawRow && (deptRow.rawRow.department_id ?? deptRow.rawRow.businessunit_id ?? deptRow.rawRow.id));
    const deptId = rawDeptId !== undefined && rawDeptId !== null ? rawDeptId : 0;
    const deptName = (deptRow?.department || (deptRow?.rawRow && (deptRow.rawRow.department_name || deptRow.rawRow.department || deptRow.rawRow.name)) || "Unassigned").trim();

    if (deptName.toLowerCase() === "unassigned" || deptId === 0) {
      return;
    }
    const targetDate = dashDate || deptRow?.selectedDate;
    const todayF = deptRow?.filters;

    let selectedBu = null;
    if (businessUnitData && businessUnitData.length > 0) {
      selectedBu = businessUnitData.find(b => {
        const bId = b.businessunit_id || b.id || b.business_unit_id;
        const bName = (b.name || b.department_name || b.businessunit || '').toLowerCase();
        return (deptId && bId === deptId) || (deptName && bName === deptName.toLowerCase());
      });
    }
    if (!selectedBu && (deptId || deptName)) {
      selectedBu = {
        businessunit_id: deptId,
        id: deptId,
        name: deptName
      };
    }

    if (selectedBu) {
      setBusinessUnitValue([selectedBu]);
    }
    if (todayF) {
      setFilters(prev => ({
        ...prev,
        ats_work_location_id: Array.isArray(todayF.location) ? todayF.location : [],
        from_date: targetDate || prev.from_date,
        to_date: targetDate || prev.to_date
      }));
      setShiftValue(Array.isArray(todayF.shift) ? todayF.shift : []);
      setEmploymentTypeValue(Array.isArray(todayF.employmentType) ? todayF.employmentType : []);
    } else if (targetDate) {
      setFilters(prev => ({
        ...prev,
        from_date: targetDate,
        to_date: targetDate
      }));
    }
    setIsDashboardView(false);
  };

  const handleShiftChange = (data, e) => {
    const targetId = data?.shift_roster_configuration_id ?? data?.shift_roster_configuration_pk ?? data?.shift_id ?? data?.id ?? data?.shift_type_id;
    if (e?.target?.checked === false || e?.type === "click") {
      setShiftValue((shiftValue || []).filter(s => {
        const sId = s?.shift_roster_configuration_id ?? s?.shift_roster_configuration_pk ?? s?.shift_id ?? s?.id ?? s?.shift_type_id;
        return sId !== targetId;
      }));
    } else {
      setShiftValue([...(shiftValue || []), data]);
    }
  };

  const handleEmploymentTypeChange = (data, e) => {
    const targetId = data?.employmenttype_id ?? data?.employment_type_id ?? data?.id;
    if (e?.target?.checked === false || e?.type === "click") {
      setEmploymentTypeValue((employmentTypeValue || []).filter(item => {
        const elId = item?.employmenttype_id ?? item?.employment_type_id ?? item?.id;
        return elId !== targetId;
      }));
    } else {
      setEmploymentTypeValue([...(employmentTypeValue || []), data]);
    }
  };

  const handleEmpNoChange = (data, e) => {
    if (e.type === "click") {
      setEmpNoValue(empNoValue.filter(element => element !== data));
    }
  };

  const handleClearFilter = () => {
    setFilters(prev => ({
      ...prev,
      employee_id: [],
      from_date: DateConvertInDbFormat(),
      to_date: DateConvertInDbFormat(),
      ats_work_location_id: [],
      dateRangeOption: "",
    }));
    setBusinessUnitValue([]);
    setShiftValue([]);
    setEmploymentTypeValue([]);
    setEmpNoValue([]);
  };

  const handleFilterChange = (event, value) => {
    if (["ats_work_location_id"].includes(event)) {
      if (value) {
        setFilters({ ...filters, [event]: value });
      } else {
        setFilters({ ...filters, [event]: "" });
      }
    }
  }
  return (
    <>
      <UnauthorizedBase
        imageUrl={imageUrl}
        companyName={decodedPayload?.companyFullName}
      >
        <Box sx={{ maxHeight: "calc(100vh - 75px)", overflowY: "auto" }}>
          <Grid container spacing={2} sx={{ pt: 3, px: 2 }} alignItems="center">
            {!isDashboardView && (
              <Typography variant="h4" sx={{ fontWeight: "bold", pl: 2 }}>
                Team Time
              </Typography>
            )}
          </Grid>
          {!isDashboardView && (
            <Grid
              container
              spacing={2}
              sx={{ pt: 2, pb: 2, px: 2, flexWrap: "wrap" }}
              alignItems="center"
            >
              <Grid
                item
                xs={6}
                sm={3.5}
                md={3}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <FormControl fullWidth>
                  <SelectableSearch
                    multiple
                    limitTags={1}
                    label="Employee"
                    value={filters?.employee_id}
                    loading={() => handleEmployees()}
                    fieldLabel="name"
                    variant="outlined"
                    name="employee_id"
                    size="small"
                    onChangeEvent={handleFilter}
                    data={employeesData}
                    isOptionEqualToValue={(option, value) => option?.employee_id === value?.employee_id}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={3.5} md={2.5}>
                <FormControl fullWidth size="small" variant="outlined">
                  <OutlinedInput
                    readOnly
                    value={
                      filters.from_date === filters.to_date
                        ? ConvertDate(filters.from_date)
                        : `${ConvertDate(filters.from_date)} - ${ConvertDate(filters.to_date)}`
                    }
                    onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                      setShowCustomRange(filters.dateRangeOption === "custom");
                    }}
                    placeholder="Date"
                    startAdornment={
                      <InputAdornment position="start" sx={{ marginRight: 1 }}>
                        <InsertInvitationIcon color="action" sx={{ fontSize: 22, mt: 0.2 }} />
                      </InputAdornment>
                    }
                    endAdornment={
                      filters?.dateRangeOption ? (
                        <InputAdornment position="end" sx={{ marginRight: 1 }}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClear();
                            }}
                            sx={{ p: 0.3 }}
                          >
                            <ClearIcon fontSize="small" sx={{ fontSize: 22, mt: 0.2 }} />
                          </IconButton>
                        </InputAdornment>
                      ) : (
                        <InputAdornment position="end">
                          <ArrowDropDownIcon sx={{ color: "action.active", pointerEvents: "none" }} />
                        </InputAdornment>
                      )
                    }
                    sx={{
                      height: 37,
                      backgroundColor: "#fff",
                      cursor: "pointer",
                      "& .MuiOutlinedInput-input": {
                        cursor: "pointer",
                        paddingLeft: "4px !important",
                        paddingRight: "0px !important",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "12px",
                      },
                    }}
                  />
                  <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={(e, reason) => {
                      if (reason === "backdropClick") {
                        const isPickerElement = e?.target && (
                          e.target.closest?.(".MuiPickersPopper-root") ||
                          e.target.closest?.(".MuiDialog-root") ||
                          e.target.closest?.(".MuiTooltip-popper")
                        );
                        if (isPickerElement) return;
                      }
                      setAnchorEl(null);
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    PaperProps={{
                      sx: {
                        width: 340,
                        mt: 0.5,
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                        borderRadius: "8px",
                      }
                    }}
                  >
                    {!showCustomRange ? (
                      <Box>
                        <MenuItem disabled sx={{ fontWeight: "bold", py: 1, px: 2 }}>
                          Date
                        </MenuItem>
                        <MenuItem onClick={() => { handleDateRangeChange("today"); setAnchorEl(null); }} sx={{ py: 1, px: 2 }}>
                          Today
                        </MenuItem>
                        <MenuItem onClick={() => { handleDateRangeChange("yesterday"); setAnchorEl(null); }} sx={{ py: 1, px: 2 }}>
                          Yesterday
                        </MenuItem>
                        <MenuItem onClick={() => { handleDateRangeChange("last7"); setAnchorEl(null); }} sx={{ py: 1, px: 2 }}>
                          Previous 7 days
                        </MenuItem>
                        <MenuItem onClick={() => { handleDateRangeChange("lastMonth"); setAnchorEl(null); }} sx={{ py: 1, px: 2 }}>
                          Last Month
                        </MenuItem>
                        <MenuItem onClick={() => setShowCustomRange(true)} sx={{ py: 1, px: 2 }}>
                          Custom Range
                        </MenuItem>
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                          <IconButton
                            size="small"
                            onClick={() => setShowCustomRange(false)}
                            sx={{ mr: 1, p: 0.5 }}
                          >
                            <ArrowBackIosNewIcon fontSize="small" />
                          </IconButton>
                          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                            Custom Range
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <FormControl size="small" sx={{ flex: 1, minWidth: 0 }}>
                            <CommonDatePicker
                              name="from_date"
                              label={<span>
                                From Date&nbsp;
                                <Tooltip title="You can select up to 45 days at a time. Dates will adjust automatically if the range is longer." placement="top-start" arrow>
                                  <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer", marginBottom: "4px" }} />
                                </Tooltip>
                              </span>}
                              size="small"
                              pickerType="date"
                              onKeyPress={(e) => e.preventDefault()}
                              pickerFormat="dd/MM/yyyy"
                              DefaultDTvalue={customFromDate}
                              maxDate={currentDate}
                              handleChange={(value) => handleCustomDateChange("from_date", value)}
                            />
                          </FormControl>
                          <FormControl size="small" sx={{ flex: 1, minWidth: 0 }}>
                            <CommonDatePicker
                              name="to_date"
                              label={<span>
                                To Date&nbsp;
                                <Tooltip title="You can select up to 45 days at a time. Dates will adjust automatically if the range is longer." placement="top-end" arrow>
                                  <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer", marginBottom: "4px" }} />
                                </Tooltip>
                              </span>}
                              pickerType="date"
                              size="small"
                              onKeyPress={(e) => e.preventDefault()}
                              pickerFormat="dd/MM/yyyy"
                              DefaultDTvalue={customToDate}
                              minDate={customFromDate}
                              maxDate={currentDate}
                              handleChange={(value) => handleCustomDateChange("to_date", value)}
                            />
                          </FormControl>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                          <Button
                            sx={{
                              fontWeight: 700,
                              borderRadius: "8px",
                              fontSize: "13px",
                              height: "32px",
                              padding: "4px 16px",
                              boxShadow: "none",
                              textTransform: "none",
                            }}
                            size="small"
                            variant="contained"
                            className="mpl-primary-btn"
                            onClick={() => {
                              handleApplyCustomRange();
                              setAnchorEl(null);
                            }}
                          >
                            Apply
                          </Button>
                        </Box>
                      </Box>
                    )}
                  </Popover>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={true} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 2 }}>
                {/* <Button
                  className="mpl-primary-btn"
                  size="small"
                  onClick={() => {
                    setIsOnLeaveKpi(false);
                    setOnLeaveOpen(true);
                  }}
                  sx={{
                    height: "37px",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                >
                  On Leave
                </Button>
                <Button
                  className="mpl-primary-btn"
                  size="small"
                  onClick={() => {
                    setIsYetToCheckInKpi(false);
                    setYetToCheckInOpen(true);
                  }}
                  sx={{
                    height: "37px",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                >
                  Yet to Check-In
                </Button> */}
                <Button
                  size="small"
                  endIcon={<FilterListIcon />}
                  onClick={() => setDrawerOpen(true)}
                  sx={{
                    color: "rgb(99, 115, 129)",
                    height: "37px",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                >
                  Filter
                </Button>
                {empdata?.length > 0 && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <Tooltip title="View Check-In/Out Chart">
                      <BarChartIcon onClick={() => setChartOpen(true)} sx={{ cursor: "pointer", color: "rgba(0, 0, 0, 0.54)" }} />
                    </Tooltip>

                    {isCsvLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      <>
                        <Tooltip title="Export CSV">
                          <CloudDownloadIcon
                            onClick={handleExportMenuOpen}
                            sx={{ cursor: "pointer", color: "rgba(0, 0, 0, 0.54)" }}
                          />
                        </Tooltip>
                        <Menu
                          anchorEl={exportAnchorEl}
                          open={Boolean(exportAnchorEl)}
                          onClose={handleExportMenuClose}
                          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                          transformOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                          <MenuItem onClick={handleExportSummarised} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 170 }}>
                            Summary Report
                            <Tooltip title="Daily attendance summary with check-in/out times, total hours & work location" placement="bottom">
                              <InfoOutlinedIcon fontSize="small" sx={{ color: 'text.secondary', ml: 1.5 }} />
                            </Tooltip>
                          </MenuItem>
                          <MenuItem onClick={handleExportConsolidated} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 170 }}>
                            Detailed Report
                            <Tooltip title="Consolidated report with full individual punch logs and location details" placement="bottom">
                              <InfoOutlinedIcon fontSize="small" sx={{ color: 'text.secondary', ml: 1.5 }} />
                            </Tooltip>
                          </MenuItem>
                        </Menu>
                      </>
                    )}

                    <Box ref={setToolbarNode} sx={{ display: 'flex', alignItems: 'center' }} />
                  </Box>
                )}
                <CustomToggle
                  isChecked={!isDashboardView}
                  handleToggleChange={handleToggleView}
                  Yestext={"Table"}
                  NoText={"Dashboard"}
                  YesTooltip={"Switch to Table View"}
                  NoTooltip={"Switch to Dashboard View"}
                  style={{ height: '37px', labelPadding: '2px 8px' }}
                />
              </Grid>
            </Grid>
          )}

          {isDashboardView ? (
            <PublicAttendanceDashboard
              isDashboardView={isDashboardView}
              setIsDashboardView={handleToggleView}
              domain={domain}
              user_id={decodedPayload?.user_id}
              reporting_manager_emp_id={decodedPayload?.userId}
              onDepartmentRowClick={handleDepartmentRowClick}
              onOnDutyClick={(params) => {
                const todayF = params?.filters;
                const targetDate = params?.date || default_date;
                if (todayF) {
                  setFilters(prev => ({
                    ...prev,
                    ats_work_location_id: Array.isArray(todayF.location) ? todayF.location : [],
                    from_date: targetDate,
                    to_date: targetDate
                  }));
                  setShiftValue(Array.isArray(todayF.shift) ? todayF.shift : []);
                  setEmploymentTypeValue(Array.isArray(todayF.employmentType) ? todayF.employmentType : []);
                } else {
                  setFilters(prev => ({
                    ...prev,
                    from_date: targetDate,
                    to_date: targetDate
                  }));
                }
                setIsDashboardView(false);
              }}
              onYetToCheckInClick={(params) => {
                setKpiFilters(params?.filters || null);
                setKpiReportingManagerId(params?.reporting_manager_emp_id || decodedPayload?.userId);
                setIsYetToCheckInKpi(true);
                setYetToCheckInOpen(true);
              }}
              onLeaveClick={(params) => {
                setKpiFilters(params?.filters || null);
                setKpiReportingManagerId(params?.reporting_manager_emp_id || decodedPayload?.userId);
                setIsOnLeaveKpi(true);
                setOnLeaveOpen(true);
              }}
            />
          ) : (
            <>

          {(filters?.ats_work_location_id?.length > 0 || businessUnitValue?.length > 0 || empNoValue?.length > 0 || shiftValue?.length > 0 || employmentTypeValue?.length > 0) && (
            <Box sx={{ px: 2, pb: 1, display: "flex", alignItems: "center", overflowX: "auto" }}>
              <TeamTimeAppliedFilter
                workLocationValue={filters?.ats_work_location_id}
                handleWorkLocationChange={handleWorkLocationChange}
                businessUnitValue={businessUnitValue}
                handleBusinessUnitChange={handleBusinessUnitChange}
                shiftValue={shiftValue}
                handleShiftChange={handleShiftChange}
                employmentTypeValue={employmentTypeValue}
                handleEmploymentTypeChange={handleEmploymentTypeChange}
                empNoValue={empNoValue}
                handleEmpNoChange={handleEmpNoChange}
                handleClearFilter={handleClearFilter}
              />
            </Box>
          )}

          <MaterialTable
            columns={[
              { title: "Emp No", width: "150px", cellStyle: { padding: "10px", textAlign: "left" }, headerStyle: { padding: "10px", textAlign: "left" }, field: "employee_no", editable: "never", hidden: true, hiddenByColumnsButton: true },
              { title: "Name", cellStyle: { padding: "10px", textAlign: "left" }, headerStyle: { padding: "10px", textAlign: "left" }, field: "employee_name", editable: "never" },
              { title: "Attendance Date", cellStyle: { padding: "10px", textAlign: "left" }, headerStyle: { padding: "10px", textAlign: "left" }, field: "record_date", editable: "never", render: rowData => { return rowData?.record_date ? ConvertDate(rowData?.record_date) : "    " } },
              { title: "Business Unit", width: "150px", cellStyle: { padding: "10px", textAlign: "left" }, headerStyle: { padding: "10px", textAlign: "left" }, field: "business_unit", editable: "never", hidden: true, hiddenByColumnsButton: true },
              { title: "Shift", width: "150px", cellStyle: { padding: "10px", textAlign: "left" }, headerStyle: { padding: "10px", textAlign: "left" }, field: "shift_name", editable: "never", hidden: true, hiddenByColumnsButton: true, render: rowData => rowData?.shift_name || rowData?.shift_type || rowData?.shift || "N/A" },
              {
                title: "Work Location", cellStyle: { padding: "10px", textAlign: "left" }, headerStyle: { padding: "10px", textAlign: "left" }, field: "work_location_name", editable: "never", hidden: !showWorkLocation, render: (rowData) => {
                  return rowData?.work_location_name || "N/A"
                }
              },
              {
                title: "In Mode",
                field: "in_mode",
                editable: "never",
                cellStyle: { padding: "10px", textAlign: "left" },
                headerStyle: { padding: "10px", textAlign: "left" },
                render: rowData => renderModeCell(rowData?.in_mode, rowData?.is_face_attendance, rowData?.in_location_display_name, rowData?.in_location_distance),
              },
              {
                title: "Out Mode",
                field: "out_mode",
                editable: "never",
                cellStyle: { padding: "10px", textAlign: "left" },
                headerStyle: { padding: "10px", textAlign: "left" },
                render: rowData => renderModeCell(rowData?.out_mode, rowData?.is_face_attendance, rowData?.out_location_display_name, rowData?.out_location_distance),
              },
              /* {
                  title: "In Location",
                  editable: "never",
                  cellStyle: { padding: "10px", textAlign: "left" },
                  headerStyle: { padding: "10px", textAlign: "left" },
                  render: (rowData) => {
                  if (!rowData?.is_face_attendance || !rowData?.in_location_display_name) {
                      return "-";
                  }

                  const tooltipText = (
                      <>
                      <div>• Marked at: {rowData.in_location_display_name}</div>
                      {rowData.in_location_distance && (
                          <div>• Distance from office: {rowData.in_location_distance}</div>
                      )}
                      </>
                  );

                  return (
                      <div style={{ maxWidth: "150px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <span
                          style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              flex: 1,
                          }}
                          >
                          {rowData.in_location_display_name}
                          </span>

                          <Tooltip title={tooltipText} arrow>
                          <InfoOutlinedIcon
                              fontSize="small"
                              color="primary"
                              style={{ cursor: "pointer" }}
                          />
                          </Tooltip>
                      </div>

                      {rowData.in_location_distance && (
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>
                          ({rowData.in_location_distance})
                          </div>
                      )}
                      </div>
                  );
                  },
              },

              {
                  title: "Out Location",
                  editable: "never",
                  cellStyle: { padding: "10px", textAlign: "left" },
                  headerStyle: { padding: "10px", textAlign: "left" },
                  render: (rowData) => {
                  if (!rowData?.is_face_attendance || !rowData?.out_location_display_name) {
                      return "-";
                  }

                  const tooltipText = (
                      <>
                      <div>• Marked at: {rowData.out_location_display_name}</div>
                      {rowData.out_location_distance && (
                          <div>• Distance from office: {rowData.out_location_distance}</div>
                      )}
                      </>
                  );

                  return (
                      <div style={{ maxWidth: "150px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <span
                          style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              flex: 1,
                          }}
                          >
                          {rowData.out_location_display_name}
                          </span>

                          <Tooltip title={tooltipText} arrow>
                          <InfoOutlinedIcon
                              fontSize="small"
                              color="primary"
                              style={{ cursor: "pointer" }}
                          />
                          </Tooltip>
                      </div>

                      {rowData.out_location_distance && (
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>
                          ({rowData.out_location_distance})
                          </div>
                      )}
                      </div>
                  );
                  },
              }, */

              { title: "First Check-In", cellStyle: { padding: "10px", textAlign: "center" }, headerStyle: { padding: "10px", textAlign: "center" }, field: "in_time", editable: "never", render: rowData => renderTimeCell(rowData?.in_time) },

              { title: "Last Check-Out", cellStyle: { padding: "10px", textAlign: "center" }, headerStyle: { padding: "10px", textAlign: "center" }, field: "out_time", editable: "never", render: rowData => renderTimeCell(rowData?.out_time) },
              { title: "Total Hours", cellStyle: { padding: "10px", textAlign: "center" }, headerStyle: { padding: "10px", textAlign: "center" }, field: "total_seconds", editable: "never", render: rowData => rowData?.total_seconds ? formatTimeDuration(rowData?.total_seconds) : "" },
              {
                field: "in_out_transaction",
                title: "Punch Record",
                editable: "never",
                headerStyle: {
                  maxWidth: 100,
                  minWidth: 100,
                  padding: "5px 0px 5px 10px",
                  textAlign: "center",
                },
                cellStyle: {
                  maxWidth: 100,
                  minWidth: 100,
                  textAlign: "center",
                  padding: "5px 0px 5px 13px",
                },
                render: (rowData) => {
                   const isPunchEnabled = ['App Attendance', 'Face Attendance', 'Whatsapp Attendance'].includes(rowData?.in_mode) ||
                                ['App Attendance', 'Face Attendance', 'Whatsapp Attendance'].includes(rowData?.out_mode);
                  return (
                    <Tooltip title={isPunchEnabled ? "View Punch Record" : "Punch record is not available for this mode of attendance."}>
                      <span>
                        <IconButton
                          color="primary"
                          disabled={!isPunchEnabled}
                          onClick={() => handleShowTransactions(rowData)}
                        >
                          <InfoOutlinedIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )
                },
              },
            ]}
            data={empdata}
            isLoading={isLoading}
            options={{
              maxBodyHeight: "calc(100vh - 235px)",
              minBodyHeight: "calc(100vh - 235px)",
              rowStyle: { fontSize: "13px" },
              headerStyle: {
                backgroundColor:
                  theme?.palette?.mode === "light"
                    ? "#fff"
                    : theme.palette.grey[500],
                color:
                  theme?.palette?.mode === "light"
                    ? "#000"
                    : theme.palette.grey[800],
                fontWeight: "bold",
                padding: "10px 10px 10px 13px",
              },
              sorting: true,
              search: false,
              searchText: "",
              searchFieldAlignment: "right",
              searchAutoFocus: true,
              searchFieldVariant: "standard",
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              paginationPosition: "bottom",
              exportFileName: "Bio Metric",
              exportAllData: true,
              exportButton: false,
              addRowPosition: "first",
              selection: false,
              actionsColumnIndex: -1,
              grouping: false,
              columnsButton: true,
              toolbar: true,
            }}
            title=""
            actions={[]}
            components={{
              Toolbar: (props) => {
                if (!toolbarNode) return <Box sx={{ display: 'none' }}><MTableToolbar {...props} /></Box>;
                return ReactDOM.createPortal(
                  <Box sx={{
                    "& .MuiToolbar-root": { minHeight: 0, padding: 0 },
                    "& .MuiIconButton-root": {
                      padding: 0,
                      color: "rgba(0, 0, 0, 0.54) !important",
                      "&:hover": { backgroundColor: "transparent" }
                    },
                    "& .MuiSvgIcon-root": { color: "rgba(0, 0, 0, 0.54) !important" }
                  }}>
                    <MTableToolbar {...props} />
                  </Box>,
                  toolbarNode
                );
              },
              Body: (props) =>
                empdata?.length === 0 ? (
                  <tbody>
                    <tr>
                      <td colSpan={props.columns.length}>
                        <Box
                          sx={{
                            height: "calc(100vh - 235px)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#888",
                            fontSize: "16px",
                          }}
                        >
                          No records to display
                        </Box>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <MTableBody {...props} />
                ),
            }}
          />
          <Box
            sx={{
              textAlign: "center",
              padding: "10px 25px 10px 0px",
              fontSize: { xs: "10px", sm: "14px" },
              color: "rgba(69, 80, 86, 0.74)",
              marginBottom: "4px"
            }}
          >
            <strong>powered by Meepl</strong>
          </Box>
          <Popup
            fullWidth={true}
            maxWidth="sm"
            title="Attendance Insights"
            openPopup={chartOpen}
            setOpenPopup={setChartOpen}
            dialogContentSx={{ overflow: 'hidden' }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', height: 350, overflow: 'hidden' }}>
              {/* Header */}
              <Box sx={{ pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                <Typography sx={{ fontSize: '1.25rem', fontWeight: 800, color: '#1e293b' }}>
                  {getReportTitle()}
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
                  Aggregate check-in and check-out activity for the selected date range
                </Typography>
              </Box>

              {/* Chart section */}
              <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden' }}>
                <Box sx={{ p: 1, border: '1px solid #f1f5f9', borderRadius: '16px', bgcolor: '#fff', overflow: 'hidden' }}>
                  <Chart
                    options={getChartData().options}
                    series={getChartData().series}
                    type="bar"
                    height={240}
                  />
                </Box>
              </Box>
            </Box>
          </Popup>
          </>
          )}

          <YetToCheckInPopup
            openPopup={yetToCheckInOpen}
            setOpenPopup={setYetToCheckInOpen}
            fromDate={filters?.from_date || filters?.full_date}
            toDate={filters?.to_date || filters?.full_date}
            isKpi={isYetToCheckInKpi}
            dashboardFilters={kpiFilters}
            filters={filters}
            businessUnitValue={businessUnitValue}
            shiftValue={shiftValue}
            employmentTypeValue={employmentTypeValue}
            empNoValue={empNoValue}
            domain_name={domain}
            user_id={decodedPayload?.user_id}
            reporting_manager_emp_id={isYetToCheckInKpi ? kpiReportingManagerId : decodedPayload?.userId}
          />

          <OnLeavePopup
            openPopup={onLeaveOpen}
            setOpenPopup={setOnLeaveOpen}
            fromDate={filters?.from_date || filters?.full_date}
            toDate={filters?.to_date || filters?.full_date}
            isKpi={isOnLeaveKpi}
            dashboardFilters={kpiFilters}
            domain_name={domain}
            emp_user_id={decodedPayload?.user_id}
            reporting_manager_emp_id={isOnLeaveKpi ? kpiReportingManagerId : decodedPayload?.userId}
          />

        </Box>
      </UnauthorizedBase>
      <Dialog
        open={transactionDialogOpen}
        onClose={() => setTransactionDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {transactionVisitor
            ? `Punch In-Out Detail for ${transactionVisitor?.employee_name}`
            : "Punch In-Out Detail"}
        </DialogTitle>
        <DialogContent dividers>
          {transactionLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          ) : transactionRows?.length > 0 ? (
            <>
              {transactionSummary && (
                <Box sx={{ display: 'flex', gap: 3, mb: 2, p: 2, bgcolor: '#f8f9fa', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#000' }}>
                    Total Punch-Ins: {transactionSummary?.total_check_ins || 0}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#000' }}>
                    Total Punch-Outs: {transactionSummary?.total_check_outs || 0}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#000' }}>
                    For Selected Date: {transactionVisitor?.record_date ? ConvertDate(transactionVisitor.record_date) : '-'}
                  </Typography>
                </Box>
              )}
              <TableContainer component={Box} sx={{ mt: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <Table size="small">
                  <TableHead sx={{
                    backgroundColor: theme?.palette?.mode === "light" ? "#fff" : theme.palette.grey[500],
                    borderBottom: "1px solid #e0e0e0"
                  }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', color: theme?.palette?.mode === "light" ? "#000" : theme.palette.grey[800] }}>Punch In Time</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: theme?.palette?.mode === "light" ? "#000" : theme.palette.grey[800] }}>In Mode & Location</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: theme?.palette?.mode === "light" ? "#000" : theme.palette.grey[800] }}>Punch Out Time</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: theme?.palette?.mode === "light" ? "#000" : theme.palette.grey[800] }}>Out Mode & Location</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(() => {
                      const rows = transactionRows?.map((curr) => {
                        return {
                            in_punch: curr?.in_time ? {
                                punch_time: curr?.in_time,
                                location_name: curr?.in_location_name,
                                mode: curr?.attendance_type === 'Whatsapp Attendance'
                                    ? 'Whatsapp Attendance'
                                    : (curr?.in_location ? 'App Attendance' : 'Face Attendance')
                            } : null,
                            out_punch: curr?.out_time ? {
                                punch_time: curr?.out_time,
                                location_name: curr?.out_location_name,
                                mode: curr?.attendance_type === 'Whatsapp Attendance'
                                    ? 'Whatsapp Attendance'
                                    : (curr?.out_location ? 'App Attendance' : 'Face Attendance')
                            } : null
                        };
                      });

                      if (rows.length === 0) {
                        return (
                          <TableRow>
                            <TableCell colSpan={4} align="center">No data</TableCell>
                          </TableRow>
                        );
                      }

                      return rows.map((row, idx) => {
                        // Process In
                        let inLocName = "";
                        let inLocDist = null;
                        if (row?.in_punch?.location_name) {
                          try {
                            const locObj = JSON.parse(row.in_punch.location_name);
                            inLocName = locObj?.displayName || "";
                            inLocDist = locObj?.coordinateDiff ? formatDistance(locObj.coordinateDiff) : null;
                          } catch (e) {
                            inLocName = row.in_punch.location_name;
                          }
                        }

                        // Process Out
                        let outLocName = "";
                        let outLocDist = null;
                        if (row?.out_punch?.location_name) {
                          try {
                            const locObj = JSON.parse(row.out_punch.location_name);
                            outLocName = locObj?.displayName || "";
                            outLocDist = locObj?.coordinateDiff ? formatDistance(locObj.coordinateDiff) : null;
                          } catch (e) {
                            outLocName = row.out_punch.location_name;
                          }
                        }

                        return (
                          <TableRow
                            key={idx}
                            sx={{
                              backgroundColor: theme?.palette?.mode === "light"
                                ? idx % 2 === 0 ? "#f3e8ff" : "#ffffff"
                                : idx % 2 === 0 ? theme.palette.grey[800] : theme.palette.grey[900],
                              "&:hover": {
                                backgroundColor: theme?.palette?.mode === "light" ? "#e9d5ff" : theme.palette.grey[700],
                              }
                            }}
                          >
                            <TableCell sx={{ borderBottom: "1px solid #e0e0e0" }}>{renderTimeCell(row?.in_punch?.punch_time, false)}</TableCell>
                            <TableCell sx={{ borderBottom: "1px solid #e0e0e0" }}>
                              {row?.in_punch ? renderModeCell(
                                row.in_punch.mode,
                                row.in_punch.mode === 'Face Attendance',
                                inLocName,
                                inLocDist
                              ) : "-"}
                            </TableCell>
                            <TableCell sx={{ borderBottom: "1px solid #e0e0e0" }}>{renderTimeCell(row?.out_punch?.punch_time, false)}</TableCell>
                            <TableCell sx={{ borderBottom: "1px solid #e0e0e0" }}>
                              {row?.out_punch ? renderModeCell(
                                row.out_punch.mode,
                                row.out_punch.mode === 'Face Attendance',
                                outLocName,
                                outLocDist
                              ) : "-"}
                            </TableCell>
                          </TableRow>
                        );
                      });
                    })()}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Typography>No punch in-out detail data found for this employee.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTransactionDialogOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: { width: "25%" }
        }}
      >
        <TeamTimeFilter
          handleClearFilter={handleClearFilter}
          worklocationData={worklocationData?.values || []}
          workLocationValue={filters?.ats_work_location_id || []}
          handleWorkLocationChange={handleWorkLocationChange}
          setWorkLocationValue={(val) => setFilters({ ...filters, ats_work_location_id: val })}
          businessUnitData={businessUnitData}
          businessUnitValue={businessUnitValue}
          handleBusinessUnitChange={handleBusinessUnitChange}
          setBusinessUnitValue={setBusinessUnitValue}
          shiftData={shiftData}
          shiftValue={shiftValue}
          handleShiftChange={handleShiftChange}
          setShiftValue={setShiftValue}
          employmentTypeData={employmentTypeData}
          employmentTypeValue={employmentTypeValue}
          handleEmploymentTypeChange={handleEmploymentTypeChange}
          setEmploymentTypeValue={setEmploymentTypeValue}
          empNoValue={empNoValue}
          handleEmpNoChange={handleEmpNoChange}
          setEmpNoValue={setEmpNoValue}
        />
      </Drawer>

    </>
  );
};
const addDays = (dateStr, days) => {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return DateConvertInDbFormat(d);
};

const subtractDays = (dateStr, days) => {
  const d = new Date(dateStr);
  d.setDate(d.getDate() - days);
  return DateConvertInDbFormat(d);
};

const getDayDiff = (from, to) => {
  const start = new Date(from);
  const end = new Date(to);
  return Math.abs(
    Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1
  );
};


export default TeamTimePublic;